import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const DateRangePicker = (props) => {
    const [startDate, setStartDate] = useState(
        props?.defaultValues?.start_date ? new Date(props?.defaultValues?.start_date) : null,
    );
    const [endDate, setEndDate] = useState(
        props?.defaultValues?.end_date ? new Date(props?.defaultValues?.end_date) : null,
    );
    const [selectedOption, setSelectedOption] = useState({});

    const setRange = (range) => {
        setSelectedOption(range);
        if (range?.id === 'custom') return;
        const { start_date, end_date } = props.selectRange(range);
        setStartDate(new Date(start_date));
        setEndDate(new Date(end_date));
    };

    const onChangeTime = (date) => {
        props.emptyRange();
        let startDate = date[0];
        let endDate = date[1];
        if (props.isFromGSC && endDate) {
            const endOfWeek = moment(date[1]).endOf('week').toDate();
            endDate = endOfWeek;
        }
        setStartDate(startDate);
        setEndDate(endDate);
        const choice = {
            label: 'Custom',
            key: 'dates',
            id: 'custom',
            values: {
                start_date: { value: startDate },
                end_date: { value: endDate },
            },
        };
        setSelectedOption(choice);
    };

    const onChange = (key, value) => {
        props.emptyRange();
        if (key === 'start') {
            setStartDate(value);
        } else {
            setEndDate(value);
        }
    };

    const onApply = () => {
        if (selectedOption && selectedOption.id !== 'custom') {
            props.selectRange(selectedOption);
        } else {
            props.emptyRange();
        }
        props.updateSelect({
            start_date: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
            end_date: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
        });
        props.onClose();
    };

    let options = [];

    if (props.hasOptions) {
        options = [...props.options];
        options.unshift({
            label: 'Custom',
            key: 'dates',
            id: 'custom',
            values: {
                start_date: null,
                end_date: null,
            },
        });
    }

    return (
        <>
            <div
                className={`date-picker-container ${props.isFromGSC ? 'from-gsc-reports' : ''}`}
                style={{
                    width: props.hasOptions ? '450px' : '340px',
                }}
            >
                {/* Sidebar with predefined date ranges */}
                {props.hasOptions && (
                    <div className="date-picker-sidebar">
                        {options.map((range) => (
                            <button
                                key={range.id}
                                className={`date-range-button ${
                                    range.id === selectedOption?.id ? 'active' : ''
                                }`}
                                onClick={() => setRange(range)}
                            >
                                {range.label}
                            </button>
                        ))}
                    </div>
                )}

                {/* Date Picker section */}
                <div
                    className="date-picker-content"
                    style={{
                        width: props.hasOptions ? '70%' : '100%',
                    }}
                >
                    <h3 className="date-picker-title">{props.header ?? 'Analyze Content'}</h3>
                    <div className="date-picker-inputs">
                        <div>
                            <label>Start Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => onChange('start', date)}
                                className="date-input"
                                open={false}
                                minDate={props.minDate ? new Date(props.minDate) : null}
                                maxDate={props.maxDate ? new Date(props.maxDate) : null}
                            />
                        </div>
                        <div>
                            <label>End Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => onChange('end', date)}
                                className="date-input"
                                open={false}
                                minDate={props.minDate ? new Date(props.minDate) : null}
                                maxDate={props.maxDate ? new Date(props.maxDate) : null}
                            />
                        </div>
                    </div>

                    {/* Centered Calendar */}
                    <div className="date-picker-calendar">
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => onChangeTime(date)}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            inline
                            minDate={props.minDate ? new Date(props.minDate) : null}
                            maxDate={props.maxDate ? new Date(props.maxDate) : null}
                            showWeekNumbers={props.isFromGSC}
                            showWeekPicker={props.isFromGSC}
                        />
                    </div>

                    {/* Buttons */}
                    <div className="date-picker-buttons">
                        <button
                            className="clear-button"
                            onClick={() => {
                                setStartDate(null);
                                setEndDate(null);
                            }}
                        >
                            Clear
                        </button>
                        <button className="analyze-button" onClick={onApply}>
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DateRangePicker;
